module.exports = __webpack_public_path__ + "static/media/approach-diligence.7421f3d0.svg";